
import React from "react";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

interface CompensatingFactorsProps {
  residualIncome: boolean;
  onChange: (checked: boolean) => void;
}

const CompensatingFactors: React.FC<CompensatingFactorsProps> = ({ residualIncome, onChange }) => {
  return (
    <div className="space-y-3 pt-2">
      <Label>Additional Compensating Factors</Label>
      
      <div className="flex items-start space-x-2">
        <Checkbox
          id="residualIncome"
          checked={residualIncome}
          onCheckedChange={onChange}
        />
        <div className="grid gap-1.5 leading-none">
          <label
            htmlFor="residualIncome"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Strong Residual Income
          </label>
          <p className="text-sm text-muted-foreground">
            Significant income remaining after all expenses
          </p>
        </div>
      </div>
    </div>
  );
};

export default CompensatingFactors;
